import ApiHelper from "@/api/ApiHelper"

export default {
    async reportById(table, reportId, filter) {
        var headers = {
            method: "POST",
            redirect: "follow",
            headers: { "Content-Type": "application/json", Authorization: "Bearer " + localStorage.token, },
        };

        let data = JSON.stringify({
            filter: filter,
            token: localStorage.token,
        })

        // return Api.post("/v1/qb/trading/reports/" + reportId + "/run?table_id=" + table, 
        // data, headers);

        let url = "/v1/qb/trading/reports/" + reportId + "/run?table_id=" + table;
        return await ApiHelper.getResult(url, data, headers);
    },

    async getAll() {
        var headers = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            token: localStorage.token,
        })

        // return Api.get("/v1/individuals", 
        // data, headers);
        let url = "/v1/individuals";
        return await ApiHelper.getResult(url, data, headers);
    },
    async addIndividualsToOwnerSizeZones(id, params) {
        console.log("addIndividualsToOwnerSizeZones");
        var headers = {
            method: "POST",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            data: params,
        })
        console.log(data);
        // return Api.post(`/v1/owners/${id}/individuals`, 
        // data, headers);
        let url = `/v1/owners/${id}/individuals`;
        return await ApiHelper.getResult(url, data, headers);
    },

    async deleteByRid(rid) {
        var headers = {
            method: "DELETE",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            token: localStorage.token,
        })

        // return Api.delete("/v1/individuals/rid/" + rid, 
        // data, headers);
        let url = "/v1/individuals/rid/" + rid;
        return await ApiHelper.getResult(url, data, headers);
    },

    async getContactsByCargoAndOwner(cargoId, ownerId, type = 'individuals') {
        var headers = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            token: localStorage.token,
        })

        let url = type === 'contacts' 
            ? `/v1/cargoes/${cargoId}/owners/${ownerId}/contacts`
            : `/v1/cargoes/${cargoId}/owners/${ownerId}/individuals`;
        return await ApiHelper.getResult(url, data, headers);
    },
    async updateContact(cargoId, ownerId, contactId, contactData) {
        var headers = {
            method: "PUT",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            ...contactData,
            token: localStorage.token,
        })

        let url = `/v1/cargoes/${cargoId}/owners/${ownerId}/individuals/${contactId}`;
        return await ApiHelper.getResult(url, data, headers);
    },

    async updateIndividuals(cargoId, ownerId, individuals) {
        var headers = {
            method: "PUT",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            individuals: individuals,
            token: localStorage.token,
        })

        let url = `/v1/cargoes/${cargoId}/owners/${ownerId}/individuals`;
        return await ApiHelper.getResult(url, data, headers);
    },

    // Create new contacts
    async createContacts(cargoId, ownerId, contacts) {
        var headers = {
            method: "POST",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            contacts: contacts,
            token: localStorage.token,
        })

        let url = `/v1/cargoes/${cargoId}/owners/${ownerId}/contacts`;
        return await ApiHelper.getResult(url, data, headers);
    },

    // Update existing contacts
    async updateContacts(cargoId, ownerId, contacts) {
        var headers = {
            method: "PUT",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            contacts: contacts,
            token: localStorage.token,
        })

        let url = `/v1/cargoes/${cargoId}/owners/${ownerId}/contacts`;
        return await ApiHelper.getResult(url, data, headers);
    },

    // Delete contacts by IDs
    async deleteContacts(cargoId, ownerId, contactIds) {
        console.log("Delete contacts request:", {
            cargoId,
            ownerId,
            contactIds,
            token: localStorage.token ? "Present" : "Missing"
        });

        var headers = {
            method: "DELETE",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
        };

        let data = JSON.stringify({
            contact_ids: contactIds,
            token: localStorage.token,
        })

        console.log("Delete request data:", data);
        console.log("Delete request headers:", headers);

        let url = `/v1/cargoes/${cargoId}/owners/${ownerId}/contacts`;
        return await ApiHelper.getResult(url, data, headers);
    }
}